<template>
  <div class="viewport-center">
    <loader />
  </div>
</template>

<script lang="ts" setup>
import Loader from './Loader.vue';
</script>

<style lang="postcss" scoped>
.viewport-center {
  display: flex;
  left: 50%;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
